/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { DocumentDisplayModel as AceXFoundPortalCoreCaqModelsDocumentDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';

@Injectable({
providedIn: 'root',
})

export class DocumentService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiDocumentEntityIdUploadFinanzplanPost
   */
  static readonly ApiDocumentEntityIdUploadFinanzplanPostPath = '/api/Document/{entityId}/UploadFinanzplan';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentEntityIdUploadFinanzplanPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentEntityIdUploadFinanzplanPost$Plain$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    entityId: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentEntityIdUploadFinanzplanPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('entityId', params.entityId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentEntityIdUploadFinanzplanPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentEntityIdUploadFinanzplanPost$Plain(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    entityId: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<string> {

    return this.apiDocumentEntityIdUploadFinanzplanPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentEntityIdUploadFinanzplanPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentEntityIdUploadFinanzplanPost$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    entityId: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentEntityIdUploadFinanzplanPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('entityId', params.entityId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentEntityIdUploadFinanzplanPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentEntityIdUploadFinanzplanPost(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    entityId: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<string> {

    return this.apiDocumentEntityIdUploadFinanzplanPost$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiDocumentAnfrageIdUploadVerwendungsnachweisPost
   */
  static readonly ApiDocumentAnfrageIdUploadVerwendungsnachweisPostPath = '/api/Document/{anfrageId}/UploadVerwendungsnachweis';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentAnfrageIdUploadVerwendungsnachweisPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentAnfrageIdUploadVerwendungsnachweisPost$Plain$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    projektberichtId?: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentAnfrageIdUploadVerwendungsnachweisPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('projektberichtId', params.projektberichtId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentAnfrageIdUploadVerwendungsnachweisPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentAnfrageIdUploadVerwendungsnachweisPost$Plain(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    projektberichtId?: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<AceXFoundPortalCoreCaqModelsDocumentDisplayModel> {

    return this.apiDocumentAnfrageIdUploadVerwendungsnachweisPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsDocumentDisplayModel)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentAnfrageIdUploadVerwendungsnachweisPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentAnfrageIdUploadVerwendungsnachweisPost$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    projektberichtId?: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentService.ApiDocumentAnfrageIdUploadVerwendungsnachweisPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('projektberichtId', params.projektberichtId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDocumentAnfrageIdUploadVerwendungsnachweisPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentAnfrageIdUploadVerwendungsnachweisPost(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    projektberichtId?: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<AceXFoundPortalCoreCaqModelsDocumentDisplayModel> {

    return this.apiDocumentAnfrageIdUploadVerwendungsnachweisPost$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsDocumentDisplayModel)
    );
  }

}